<template>
<v-container fluid class="weaver-get">
    <v-layout align-center column>
        <v-img width="100%" max-width="540px" max-height="520px" style="margin-top:100px;padding-left:10px;padding-right:10px" position="center center"  src="~@/assets/images/weaversmall.png" contain="true" />
    </v-layout>
    <v-row>
        <v-col cols="12">
            <v-row align="start" justify="center">
                <v-card width="250px" height="100px" style="background: #2d2f31;margin:10px">
                    <a href="//www.google.com">
                        <v-img position="center center"  src="~@/assets/images/google-play-badge.png" contain="true" />
                    </a>
                </v-card>
                  <v-card width="250px"  height="100px" style="background: #2d2f31;margin:10px">
                       <a href="//www.google.com">
                     <v-img width="250px" height="65px" style="margin-top:17px"  position="center center"  src="~@/assets/images/app_store_badge.png" contain="true" />
                     </a>
                </v-card>
            </v-row>
        </v-col>
    </v-row>

  <v-layout align-center justify-center row  style="margin:10px;">
        <a href="//www.facebook.com/weavertalk/">
            <v-img position="center center" max-width="96px" style="margin:5px" src="~@/assets/images/facebook.png" contain="true" />
        </a>
            <a href="//twitter.com/Weaver35139377">
            <v-img position="center center" max-width="96px" style="margin:5px"  src="~@/assets/images/twitter.png" contain="true" />
        </a>
            <a href="//reddit.com/r/weavertalk/">
            <v-img position="center center" max-width="96px" style="margin:5px"  src="~@/assets/images/reddit.png" contain="true" />
        </a>
            <a href="//discord.gg/gsAhJBs">
            <v-img position="center center" max-width="96px" style="margin:5px"  src="~@/assets/images/discord.png" contain="true" />
        </a>
            <a href="mailto:contact@weavertalk.com">
            <v-img position="center center" max-width="96px" style="margin:5px"  src="~@/assets/images/email.png" contain="true" />
        </a>
    </v-layout>
</v-container>

</template>

<script>
export default {
    name: 'WeaverGet',
    data () {
        return {
            key: 'value',
        }
    }
};

</script>

<style scoped>
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}
.weaver-get {
    background: #222222;
    width: 100%;
    height: 1000px;
    padding-top: 100px;
}
</style>